module.exports = __webpack_public_path__ + "static/media/weight.d80959c8.svg";